module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst overtime = resourceData.value || {}\nconst durationOvertime          = utils.number.format(overtime.durationOvertime || 0, { decimals: 1 }, 'float').formatted\nconst netPriceOvertimePremium   = utils.number.format(overtime.netPriceOvertimePremium || 0, { decimals: 2 }, 'float').formatted\nconst hourlyRateOvertimePremium = utils.number.format(overtime.hourlyRateOvertimePremium || 0, { decimals: 2 }, 'float').formatted\n%><div><%- storage.__('document.invoice.overtime', {\ndurationOvertime,\nnetPriceOvertimePremium,\nhourlyRateOvertimePremium,\n}) %></div>"
  , __filename = "components/templates/core/documents/invoice/costCenters/fields/overtime.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const overtime = resourceData.value || {}
const durationOvertime          = utils.number.format(overtime.durationOvertime || 0, { decimals: 1 }, 'float').formatted
const netPriceOvertimePremium   = utils.number.format(overtime.netPriceOvertimePremium || 0, { decimals: 2 }, 'float').formatted
const hourlyRateOvertimePremium = utils.number.format(overtime.hourlyRateOvertimePremium || 0, { decimals: 2 }, 'float').formatted

    ; __line = 6
    ; __append("<div>")
    ; __append( storage.__('document.invoice.overtime', {
durationOvertime,
netPriceOvertimePremium,
hourlyRateOvertimePremium,
}) )
    ; __line = 10
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/invoice/costCenters/fields/overtime.ejs

}